module.exports = __webpack_public_path__ + "img/blue.1344e6a5.png";